import {
  Box,
  Collapse,
  Flex,
  Text,
  List,
  ListIcon,
  ListItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { FaChevronDown, FaChevronRight, FaSignOutAlt  } from "react-icons/fa";
import { adminSidebarData } from "./SidebarData";
import Cookies from "js-cookie";
import { UseApi } from "../../libraries/UseApi";
import { UserInfoContext } from "../../provider/UserInfoProvider";

const AdminSidebar = ({ onClose, ...rest }) => {
  const location = useLocation();
  const navigate = useNavigate(); 
  const { postApi } = UseApi();
  const { token } = useContext(UserInfoContext);

  const handleLogout = () => {
    // Clear any stored tokens or session
    Cookies.remove("token");
    handleLogoutApiCall();
    // Redirect to login page
    navigate("/sign-in");
  };

  const handleLogoutApiCall = () => {
    postApi(
      `${process.env.REACT_APP_API_URL}/auth/logout`, {}, { token: token },
      (response) => {
        // レスポンスチェック
        if (response.isSuccess === false) {
          return;
        }
      }
    );
  }

  return (
    <Box
      pos="fixed"
      h="100vh"
      w="250px"
      bg={useColorModeValue("white", "gray.800")}
      borderRightWidth="1px"
      boxShadow="md"
      p="4"
      {...rest}
    >
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        管理者
      </Text>

      <List spacing={2}>
        {adminSidebarData.map((item, index) => (
          <SidebarItem
            key={index}
            item={item}
            currentPath={location.pathname}
            onClose={onClose}
          />
        ))}
        <ListItem mt={4}>
          <Flex
            onClick={handleLogout}
            align="center"
            cursor="pointer"
            p="2"
            borderRadius="md"
            _hover={{ bg: "orange.100" }}
            color="red.500"
          >
            <Text fontSize="md" fontWeight="medium">
              ログアウト 
            </Text>
            <ListIcon as={FaSignOutAlt} color="red.500" />
          </Flex>
        </ListItem>
      </List>
    </Box>
  );
};

const SidebarItem = ({ item, currentPath, onClose }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isActive = currentPath === item.itemUrl;

  return (
    <>
      <ListItem>
        {item.subItems?.length ? (
          <Flex
            onClick={() => setIsOpen(!isOpen)}
            align="center"
            cursor="pointer"
            p="2"
            borderRadius="md"
            _hover={{ bg: "orange.100" }}
            justify="space-between"
            transition="all 0.3s"
          >
            <Text fontSize="md" fontWeight="medium">
              {item.itemName}
            </Text>
            <ListIcon as={isOpen ? FaChevronDown : FaChevronRight} />
          </Flex>
        ) : (
          <Link to={item.itemUrl} onClick={onClose}>
            <Flex
              p="2"
              borderRadius="md"
              bg={isActive ? "orange.200" : "transparent"}
              _hover={{ bg: "orange.100" }}
              fontWeight={isActive ? "bold" : "normal"}
            >
              <Text fontSize="md">{item.itemName}</Text>
            </Flex>
          </Link>
        )}
      </ListItem>

      {item.subItems && (
        <Collapse in={isOpen}>
          <List pl={4} spacing={1}>
            {item.subItems.map((sub, idx) => {
              const isSubActive = currentPath === sub.itemUrl;
              return (
                <ListItem key={idx}>
                  <Link to={sub.itemUrl} onClick={onClose}>
                    <Flex
                      p="2"
                      borderRadius="md"
                      bg={isSubActive ? "orange.100" : "transparent"}
                      _hover={{ bg: "orange.50" }}
                    >
                      <Text fontSize="sm">{sub.itemName}</Text>
                    </Flex>
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default AdminSidebar;
